import { IncidentMarker } from "./assets/Marker"
import { ObjectCard } from "../../components/ObjectCard"
import { EventAvatar, EventInfoWindow, showCardContent, EventCardContent, EventCardTitle, eventIcon } from "../../util/EventUtils"

const endpoint = "incident"

const subsort = (objects) => {
   const objectsHash = {};
   for(let i = 0; i < objects.length; i++) {
       let event = objects[i];
       let impactLevel = event.impact + " Impact";
       if(!objectsHash[impactLevel]) {
           objectsHash[impactLevel] = [];
       }
       objectsHash[impactLevel].push(event);
   } 
   return objectsHash;
}

export default {
    name: 'Incidents',
    label: 'Incident #',
    marker: IncidentMarker,
    showOnMap: true,
    wmsMapLayer: "cdot:othereventoverlays,cdot:specialeventoverlays",
    mapLayerIcon: "/mapicons/event/Incident_highclosed.png",
    sideBarCard: ObjectCard,
    showOnSidebar: true,
    infoWindow: EventInfoWindow,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 0,
    avatar: EventAvatar,
    showCardContent: showCardContent,
    cardContent: EventCardContent,
    cardTitle: EventCardTitle,
    subSort: subsort,
    getIcon: eventIcon,
    subSortOrder: ["Closed Impact", "High Impact", "Medium Impact", "Low Impact", "NoImpact Impact"],
    wmsPublish: "tasWebapp.eventpolygons.enable",
    publishLayer: "tasWebapp.eventicons.enable",
    resizeOnZoom: true
}